import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

// 活动标签
export const activeTabAtom = atom<string>('taskv2');

// 当前选中的聊天对话ID
export const currentChatIdAtom = atom<string | null>(null);

// 当前选中的任务ID
export const currentTaskIdAtom = atom<string | null>(null);



// 侧边栏折叠状态 - 使用 localStorage 持久化
export const sidebarCollapsedAtom = atomWithStorage<boolean>('v3_sidebarCollapsed', false);

// 右侧对话栏折叠状态 - 使用 localStorage 持久化
export const chatSidebarCollapsedAtom = atomWithStorage<boolean>('v3_chatSidebarCollapsed', false);

// 右侧对话栏宽度 - 使用 localStorage 持久化，单位为 rem
export const chatSidebarWidthAtom = atomWithStorage<number>('v3_chatSidebarWidth', 26.25);

// 全局快捷键帮助弹窗状态
export const globalKeymapModalOpenAtom = atom<boolean>(false);

// 个性化设置页面状态 - 类似于聊天的处理方式
export type PersonalizationView = 'settings' | 'character-selector';
export const personalizationViewAtom = atom<PersonalizationView>('settings');
export const showPersonalizationAtom = atom<boolean>(false);

// 角色卡市场页面状态 - 类似于个性化设置的处理方式
export const showCharacterMarketAtom = atom<boolean>(false);

// 布局模式 - 'mobile' 或 'desktop'
export type LayoutMode = 'mobile' | 'desktop';
export const layoutModeAtom = atom<LayoutMode>('mobile');
